import { defaultTo } from 'ramda';
import { ISmartPackageGiftDtoV4 } from '../../../../repositories/billing-tariffs/entities/ServicePackages/SmartPackageGiftDtoV4';
import { IRecommendedPackageGift } from '../../../../types/reducers/recommendedPackages';
import { getServiceIcon } from './getServiceIcon';
import { EPackageServiceType } from '../../../../../PayPackageMicrofrontend';
import { getServiceName } from './getServiceName';

export const mapGift = (gift: ISmartPackageGiftDtoV4): IRecommendedPackageGift => {
  const { count, durationInDays, price, marketingPrice } = gift;

  const serviceType = gift.serviceType as string as EPackageServiceType;

  return {
    icon: getServiceIcon(serviceType),
    name: getServiceName(serviceType),
    count,
    durationInDays,
    price,
    marketingPrice: defaultTo(0, marketingPrice),
  };
};
